import { getColorByLightness } from '$lib/helper';

import { isUsableColor } from '../../_utils/color';

import type { Theme } from '$lib/types/Theme';

export const resolveVideoTitleColor = (theme: Theme, perBlockColor: string): string => {
    const isThemeV2 = !!theme?.surface;

    if (isUsableColor(perBlockColor)) {
        return perBlockColor;
    }

    if (isThemeV2 && theme.fontColor) {
        return theme.fontColor;
    }

    return getColorByLightness('black');
};
